import { useRef, useState } from 'react';
import {
  HeadingSeoSection,
  MainPageTitle,
  SeoContent,
} from './ParentingTrustStrip/styled';

export default function HeadingSEO(props) {
  const [show, setShowMore] = useState('Read More');
  const readMoreRef = useRef();
  const myRedDiv = readMoreRef.current;

  const readMoreHandler = () => {
    if (show == 'Read More') {
      setShowMore('Read Less');
    } else {
      setShowMore('Read More');
    }

    const list = myRedDiv.classList;
    list.toggle('fullContent');
  };
  return (
    <HeadingSeoSection>
      <MainPageTitle>Mylo Parenting</MainPageTitle>
      <SeoContent ref={readMoreRef}>
        Mylo It takes a village to raise a child. A couple with a newborn child
        needs a parenting guide at each &amp; every step. Mylo is an app-based
        platform providing complete solutions for pregnancy &amp; parenting.
        Over the past few years, we have been a part of many journeys and have
        learned about a young mother and her family’s needs. We have gathered
        information from experts from various fields to find solutions for their
        queries and bring them 100+ products to help make their parenting
        journey a lot easier and trouble-free with parenting tips. The platform
        providess end-to-end personalized solutions for parents via a community
        of mothers &amp; experts. The app can also be used for product
        discovery, tracking pregnancy diet, breastfeeding, baby care, parenting
        tips for parents, baby milestones, kitchen hacks, food recipes, beauty,
        fitness, weight loss &amp; yoga, daily games &amp; horoscope, and more.
        It publishes articles related to pregnancy, health, reviews about baby
        products, food habits, baby names, and lifestyle. It also provides tools
        &amp; utilities like baby sleep music, growth tracker, due date
        calculator, pregnancy sleep music, and more. And that’s not all! Mylo
        users can also visit the Mylo Store to purchase various essentials for
        themselves and their little ones. Mylo store features three different
        ranges of products that make your family’s everyday life easier and more
        joyful!
      </SeoContent>
      <span className="readMore" onClick={readMoreHandler}>
        {show}
      </span>
    </HeadingSeoSection>
  );
}
